import { createSlice } from "@reduxjs/toolkit";

const initialState = { eid: "", techOpsActive: false };

export const techOpsUserSessionSlice = createSlice({
  name: "techOpsUserSession",
  initialState,
  reducers: {
    techOpsLogIn: (state, action) => {
      state.eid = action.payload.eid;
      state.techOpsActive = action.payload.techOpsActive;
    },
    clearTechOpsUserState: (state) => initialState,
  },
});

export const { techOpsLogIn, clearTechOpsUserState } = techOpsUserSessionSlice.actions;

export const selectTechOpsUserSession = (state) => state.techOpsUserSession;


export default techOpsUserSessionSlice.reducer;